import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from './config.service';
import { ApplicationConfig } from '@referrals/shared/models';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ApplicationConfigService {
  private headers: HttpHeaders;
  private accessPointUrl: string;

  constructor(private config: ConfigService, private http: HttpClient) {
    this.headers = new HttpHeaders({
      'Content-Type': 'application/json; charset=utf-8',
    });
    this.accessPointUrl = `${this.config.referralsApiUrl}/applicationconfig`;
  }

  public getById(id: number): Observable<ApplicationConfig[]> {
    return this.http.get<ApplicationConfig[]>(this.accessPointUrl + '/source/' + id, {
      headers: this.headers,
    });
  }

  public update(payload: ApplicationConfig): Observable<ApplicationConfig> {
    console.log('update config svc', payload);
    return this.http.put<ApplicationConfig>(
      this.accessPointUrl,
      payload,
      {
        headers: this.headers,
      }
    );
  }
}
